import { createSlice } from '@reduxjs/toolkit';
import { OrderState } from './state';
import reducers from './reducers';

const initialState: OrderState = {
  orders: [],
  order: null,
};

const orders = createSlice({
  name: 'orders',
  initialState,
  reducers,
});

export const ordersActions = { ...orders.actions };
export default orders;
